import gql from 'graphql-tag';

export const mutationVoidObject = gql`
  mutation voidObject($targetUserId: Int!, $objectId: String!, $registration: String!) {
    voidObject(targetUserId: $targetUserId, objectId: $objectId, registration: $registration)
  }
`;

export const mutationCompleteObject = gql`
  mutation completeObject($targetUserId: Int!, $objectId: String!, $registration: String!) {
    completeObject(targetUserId: $targetUserId, objectId: $objectId, registration: $registration)
  }
`;

export const mutationDeleteXAPIState = gql`
  mutation deleteXAPIState($targetUserId: Int!, $objectId: String!, $registration: String!) {
    deleteXAPIState(targetUserId: $targetUserId, objectId: $objectId, registration: $registration)
  }
`;
